import { Constants } from "@eagerdog/constants";

export type ManageCourseGroup = "Registration" | "Financials";

export interface IManageCourseSection {
  id: string;
  tabIndex: number;
  queryAliases: string[];
  group: ManageCourseGroup;
  icon: "registrations" | "transactions";
}

export const MANAGE_COURSE_GROUPS: ManageCourseGroup[] = ["Registration", "Financials"];

export const MANAGE_COURSE_REGISTRANTS_TAB_INDEX = 0;
export const MANAGE_COURSE_WAITLIST_TAB_INDEX = 1;
export const MANAGE_COURSE_TRANSACTIONS_TAB_INDEX = 2;

export const MANAGE_COURSE_SECTIONS: IManageCourseSection[] = [
  { id: "registrants", tabIndex: MANAGE_COURSE_REGISTRANTS_TAB_INDEX, queryAliases: ["Registrants", "Registered Dogs"], group: "Registration", icon: "registrations" },
  { id: "waitlist", tabIndex: MANAGE_COURSE_WAITLIST_TAB_INDEX, queryAliases: ["Waitlist"], group: "Registration", icon: "registrations" },
  { id: "transactions", tabIndex: MANAGE_COURSE_TRANSACTIONS_TAB_INDEX, queryAliases: ["Transactions"], group: "Financials", icon: "transactions" },
];

export const getRegistrantSectionLabel = (courseType?: string): string => {
  return courseType === Constants.course_type.seminar ? "Registrants" : "Registered Dogs";
};

export const getManageCourseSectionIndex = (param: string | null | undefined): number | undefined => {
  if (!param) {
    return undefined;
  }

  const match = MANAGE_COURSE_SECTIONS.find((section) => {
    return section.id === param || section.queryAliases.includes(param);
  });

  return match?.tabIndex;
};
